import 'react-native-gesture-handler';
import Home from '../Screen/Home/Home'
import Event from '../Screen/Event/Event';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import Ionicons from 'react-native-vector-icons/Ionicons'
import { useWindowDimensions } from 'react-native';
import GameBook from '../Screen/PgMaker/GameBook';
import CharacterSheetList from '../Screen/CharacterManagment/CharacterSheetList';
import { useEffect, useState } from "react";
import { db } from '../firebase/FirebaseConfig';
import {collection, getDocs, query, where} from 'firebase/firestore';
import { auth } from '../firebase/FirebaseConfig';


const Tab =createBottomTabNavigator();
const Tabnavigator = ({navigation}) =>{
    const windows= useWindowDimensions()
    const [characters, setChatacters]=useState()
    const [flip, setFlip]=useState(false)

    const user= auth.currentUser

useEffect(()=>{
    const unsubscribe = navigation.addListener('focus', () => {
        kimera()
      });
},[navigation])
  
async function kimera(){
    
    let png=[]
    let information=query(collection(db,"personaggi"),where("User","==",user.uid), where("Death","==",false));
    let querySnapshot= await getDocs(information);
          querySnapshot.forEach((docs)=>{png.push(docs.data());});
        
          setChatacters(png)
          if(png[0]==undefined){setFlip(true)}
          else{setFlip(false)}
          setTimeout(5000)
}




    return(
     
        <Tab.Navigator screenOptions={{
          headerShown:false,
          tabBarStyle:{height:60, borderRadius:15, backgroundColor:'#303030', borderTopColor:'#F9BA49', justifyContent:'center', alignSelf:'center', width:'95%' ,shadowColor:'#000000',
          shadowRadius:10, 
          shadowOpacity:1,
          shadowOffset:{width:5,height:5},},
          sceneContainerStyle:{width:windows.width, height:windows.height , alignSelf:'center', }
          
          }} > 
           
         


          <Tab.Screen name="Home" component={Home} options={{
            tabBarIcon:({size, color,})=>(
              <Ionicons name='home' size={size} color={color}/>
            ),
            tabBarShowLabel:true,
            tabBarLabelStyle: {fontSize:10, marginBottom:5, },
            tabBarActiveTintColor:'#F9BA49',
            tabBarInactiveTintColor:'#7c7d7e'

          }}/>
        
       {flip? <Tab.Screen name="Nuovo Pg" component={GameBook} options={{
            tabBarIcon:({size, color,})=>(
              <Ionicons name='add-circle' size={size} color={color}/>
            ),
            tabBarShowLabel:true,
            tabBarLabelStyle: {fontSize:10, marginBottom:5, },
            tabBarActiveTintColor:'#F9BA49',
            tabBarInactiveTintColor:'#7c7d7e',}}/>:<></>}
<Tab.Screen name="Eventi" component={Event} options={{
            tabBarIcon:({size, color,})=>(
              <Ionicons name='cube' size={size} color={color}/>),
            tabBarShowLabel:true,
            tabBarLabelStyle: {fontSize:10, marginBottom:5, },
            tabBarActiveTintColor:'#F9BA49',
            tabBarInactiveTintColor:'#7c7d7e'}}/>

<Tab.Screen name="Schede Pg" component={CharacterSheetList} options={{
            tabBarIcon:({size, color,})=>(
              <Ionicons name='cube' size={size} color={color}/>),
            tabBarShowLabel:true,
            tabBarLabelStyle: {fontSize:10, marginBottom:5, },
            tabBarActiveTintColor:'#F9BA49',
            tabBarInactiveTintColor:'#7c7d7e'}}/>


    
        </Tab.Navigator>
        
    )
}


export default Tabnavigator